import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "table table-bordered table-hover" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import { computed, onMounted, watch, shallowReactive, Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import { EditorState } from '@common/Common'
    import { guid } from '@common/Guid'
    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import RevenueEditor from '@Quest/Revenues/Components/RevenueEditor.vue'
    import type { RevenueEditorFormSubmitEventPayload } from '@Quest/Revenues/Components/RevenueEditor'
    import { RevenueEditorViewModel } from '@Quest/Revenues/Components/RevenueEditor'
    import type { RevenueAccountReadModel, RevenueAccountsReadModel } from '@Quest/Revenues/readmodels'
    import { useRevenueAccountsByStrategyIdQueryV1 } from '@Quest/Revenues/queries-vue-composables'
    import { useCreateRevenueAccountCommandV1, useUpdateRevenueAccountCommandV1, useDeleteRevenueAccountCommandV1 } from '@Quest/Revenues/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RevenuesPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const revenueEditor = shallowReactive(new RevenueEditorViewModel())

    const {
        runRevenueAccountsByStrategyIdQueryV1,
        modelRevenueAccountsByStrategyIdQueryV1
    } = useRevenueAccountsByStrategyIdQueryV1(workspaceId, strategyId)

    const rm = modelRevenueAccountsByStrategyIdQueryV1 as Ref<RevenueAccountsReadModel | null>

    const {
        invokeCreateRevenueAccountCommandV1,
        succeedCreateRevenueAccountCommandV1
    } = useCreateRevenueAccountCommandV1(workspaceId, strategyId)

    const {
        invokeUpdateRevenueAccountCommandV1,
        succeedUpdateRevenueAccountCommandV1
    } = useUpdateRevenueAccountCommandV1(workspaceId, strategyId)

    const {
        invokeDeleteRevenueAccountCommandV1,
        succeedDeleteRevenueAccountCommandV1
    } = useDeleteRevenueAccountCommandV1(workspaceId, strategyId)

    watch(rm, (model) =>
    {
        if (!model) return
        revenueEditor.close()
    })

    watch(
        [
            succeedCreateRevenueAccountCommandV1,
            succeedUpdateRevenueAccountCommandV1,
            succeedDeleteRevenueAccountCommandV1
        ],
        ([create, update, del], [prevCreate, prevUpdate, prevDel]) =>
        {
            if (
                (create && !prevCreate) ||
                (update && !prevUpdate) ||
                (del && !prevDel)
            )
            {
                runRevenueAccountsByStrategyIdQueryV1()
            }
        }
    )

    function showRevenueCreator()
    {
        revenueEditor.showCreator()
    }

    function showRevenueEditor(r: RevenueAccountReadModel)
    {
        revenueEditor.showEditor(r.Id, r.Name, r.Description)
    }

    function handleRevenueEditorFormSubmit(e: RevenueEditorFormSubmitEventPayload)
    {
        if (revenueEditor.state === EditorState.Creator)
        {
            invokeCreateRevenueAccountCommandV1({
                id: guid(),
                name: e.name,
                description: e.description
            })
        }
        else if (revenueEditor.state === EditorState.Editor)
        {
            invokeUpdateRevenueAccountCommandV1({
                id: e.id,
                name: e.name,
                description: e.description
            })
        }
    }

    function handleDeleteRevenueAccountCommand(rev: RevenueAccountReadModel)
    {
        if (confirm("Are you sure?"))
        {
            invokeDeleteRevenueAccountCommandV1({
                id: rev.Id
            })
        }
    }

    onMounted(() =>
    {
        document.title = "Revenues | TransparentChoice"
        runRevenueAccountsByStrategyIdQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(RevenueEditor, {
      viewModel: _unref(revenueEditor),
      onFormSubmit: handleRevenueEditorFormSubmit
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(CorporateNavigation, { ActivePage: "strategy" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", { class: "row" }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Revenues")
            ], -1 /* CACHED */)),
            _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, [
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-success",
                style: {"padding":"0.7em 2em"},
                onClick: showRevenueCreator
              }, "Create revenue")
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Revenue"),
                  _createElementVNode("th", { style: {"width":"120px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Accounts, (rev) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: rev.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(rev.Name), 1 /* TEXT */),
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createTextVNode(_toDisplayString(rev.Description), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[3] || (_cache[3] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (showRevenueEditor(rev))
                          }, "Edit", 8 /* PROPS */, _hoisted_6),
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (handleDeleteRevenueAccountCommand(rev))
                          }, "Delete", 8 /* PROPS */, _hoisted_7)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})